import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'copyable-input',
  templateUrl: './copyable.component.html',
  styleUrls: ['./copyable.component.css']
})
export class CopyableComponent implements OnInit {
  @Input()
  public label: string;
  @Input()
  public value: string;
  @Input()
  public textarea: boolean = false;
  @Input()
  public direction: "ltr" | "rtl" = "rtl";

  constructor(
    private clipboard: ClipboardService,
    private dialog: DialogService,
    private elem: ElementRef<HTMLElement>
  ) { }

  ngOnInit() {
  }

  copyToClipboard(event: MouseEvent) {
    event.stopPropagation();
    this.clipboard.copyFromContent(this.value);
    this.dialog.snackBar("הועתק בהצלחה", null, { timeInMs: 2500 });
  }

  select() {
    const elem = this.textarea ? this.elem.nativeElement.querySelector("textarea") : this.elem.nativeElement.querySelector("input");
    if (elem)
      elem.select();
  }

}
